import { FormInstance } from "antd/lib/form";
import React from "react";

/** Copy browser-autofilled input values into the form store before validation. */
export function syncAutofillOnSubmit(form: FormInstance) {
    return (event: React.FormEvent<HTMLElement>) => {
        event.currentTarget.querySelectorAll("input").forEach((node) => {
            const input = node as HTMLInputElement;
            if (
                !input.id ||
                !input.value ||
                input.type === "checkbox" ||
                input.type === "radio" ||
                input.type === "hidden"
            ) {
                return;
            }
            if (form.getFieldValue(input.id) !== input.value) {
                form.setFieldsValue({ [input.id]: input.value });
            }
        });
    };
}
